<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">後払い(Paidy)決済キャンセル</h2>
      <p class="point_error_notice">後払い(Paidy)決済をキャンセルしました。</p>
      <p>
        <router-link :to="{ name: 'PointGpayForm' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointGpayCancel'
}
</script>
